var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"id":"show-content-modal"},scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v(_vm._s(_vm.title))]},proxy:true}])},[_c('div',{staticClass:"modal-body p-0"},[_c('div',{staticClass:"details-container p-4 border rounded"},[_vm._v("\n      "+_vm._s(_vm.content)+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }